import { useRef, useState, useEffect } from 'react';
import { useNotification } from '../../hooks/useNotification';

const typeLabel: Record<string, { label: string; color: string }> = {
  NEW_STUDENT: { label: 'Học sinh mới', color: '#4CAF50' },
};

function NotificationBell() {
  const { notifications, unreadCount, markAllRead, clearAll } =
    useNotification();

  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // 🔥 đóng khi click ngoài
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () =>
      document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleOpen = () => {
    const nextState = !open;
    setOpen(nextState);

    if (nextState && unreadCount > 0) {
      markAllRead(); // không cần await
    }
  };

  return (
    <div ref={ref} className="relative inline-block mr-[20px]">
      {/* 🔔 Bell */}
      <button
        onClick={handleOpen}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: 22,
          position: 'relative',
          padding: '4px 8px',
        }}
      >
        🔔
        {unreadCount > 0 && (
          <span
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              background: '#f44336',
              color: 'white',
              borderRadius: '50%',
              fontSize: 11,
              minWidth: 18,
              height: 18,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
            }}
          >
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>

      {/* Dropdown */}
      {open && (
        <div
          style={{
            position: 'absolute',
            right: 0,
            top: 40,
            width: 340,
            background: 'white',
            border: '1px solid #e0e0e0',
            borderRadius: 10,
            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
            zIndex: 9999,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <div
            style={{
              padding: '12px 16px',
              borderBottom: '1px solid #f0f0f0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <strong style={{ fontSize: 15 }}>Thông báo</strong>
            {notifications.length > 0 && (
              <button
                onClick={clearAll}
                style={{
                  border: 'none',
                  background: 'none',
                  cursor: 'pointer',
                  color: '#999',
                  fontSize: 13,
                }}
              >
                Xóa tất cả
              </button>
            )}
          </div>

          {/* List */}
          <div style={{ maxHeight: 380, overflowY: 'auto' }}>
            {notifications.length === 0 ? (
              <div
                style={{
                  padding: 24,
                  textAlign: 'center',
                  color: '#aaa',
                }}
              >
                <div style={{ fontSize: 32 }}>🔕</div>
                <p style={{ margin: '8px 0 0' }}>
                  Không có thông báo
                </p>
              </div>
            ) : (
              notifications.map((n) => {
                const meta =
                  typeLabel[n.type] || {
                    label: n.type,
                    color: '#2196F3',
                  };

                return (
                  <div
                    key={n.id}
                    style={{
                      padding: '12px 16px',
                      borderBottom: '1px solid #f5f5f5',
                      background: n.isRead
                        ? 'white'
                        : '#f0f7ff',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        marginBottom: 4,
                      }}
                    >
                      <span
                        style={{
                          background: meta.color,
                          color: 'white',
                          borderRadius: 4,
                          padding: '2px 8px',
                          fontSize: 11,
                        }}
                      >
                        {meta.label}
                      </span>
                    </div>

                    <p
                      style={{
                        margin: 0,
                        fontSize: 14,
                      }}
                    >
                      {n.payload.message}
                    </p>

                    <small style={{ color: '#aaa' }}>
                      {new Date(
                        n.createdAt
                      ).toLocaleString('vi-VN')}
                    </small>
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default NotificationBell;